import { RequestService } from '../../../../../common/services/RequestService';
import { API_PROFILE } from '../../constants';

export const deleteProfileRequest = payload => {
  return RequestService.delete(API_PROFILE + '/' + payload.addToUrl);
};
